export const GROUPS_EVENTS = {
  // Groups Landing
  VIEW_SPLITS_JOIN_GROUP: 'view_splits_join_group',
  SELECT_SPLITS_JOIN_GROUP: 'select_splits_join_group',
  SELECT_SPLITS_SELECT_GROUP_MEMBER: 'select_splits_select_group_member',
  SELECT_SPLITS_MEMBER_NOT_LISTED: 'select_splits_member_not_listed',
  SELECT_SPLITS_FIRST_MEMBER_WRITES_NAME:
    'select_splits_first_member_writes_name',
  VIEW_SPLITS_JOIN_GROUP_FIRST_TIME: 'view_splits_join_group_first_time',
  SELECT_SPLITS_PHONE_NUMBER_CONTINUE: 'select_splits_phone_number_continue',
  VIEW_SPLITS_OTP_ENTER_CODE: 'view_splits_otp_enter_code',
  SELECT_SPLITS_OTP_ENTER_CODE: 'select_splits_otp_enter_code',
  API_SPLITS_OTP_SUCCESS: 'api_splits_otp_success',
  API_SPLITS_OTP_ERROR: 'api_splits_otp_error',
  // Groups Dashboard
  VIEW_SPLITS_GROUP: 'view_splits_group',
  SELECT_SPLITS_INVITE_MEMBER: 'select_splits_invite_member',
  SELECT_SPLITS_ADD_EXPENSE: 'select_splits_add_expense',
  SELECT_SPLITS_ADD_EXPENSE_CONFIRM: 'select_splits_add_expense_confirm',
  API_SPLITS_ADD_EXPENSE_SUCCESS: 'api_splits_add_expense_success',
  API_SPLITS_ADD_EXPENSE_ERROR: 'api_splits_add_expense_error',
  SELECT_SPLITS_YOU_ARE_OWED: 'select_splits_you_are_owed',
  SELECT_SPLITS_YOU_OWE: 'select_splits_you_owe',
  SELECT_SPLITS_SETTLE_ONE_DEBT: 'select_splits_settle_one_debt',
  SELECT_SPLITS_SETTLE_CONFIRM_RECEIVED:
    'select_splits_settle_confirm_received',
  SELECT_SPLITS_SETTLE_MARK_AS_PAID: 'select_splits_settle_mark_as_paid',
  SELECT_SPLITS_SETTLE_PAY_MEMBER: 'select_splits_settle_pay_member',
  SELECT_SPLITS_SETTLE_ALL: 'select_splits_settle_all',
  SELECT_SPLITS_SETTLE_ALL_MARK_AS_PAID:
    'select_splits_settle_all_mark_as_paid',
  SELECT_SPLITS_SETTLE_ALL_CONFIRM_RECEIVED:
    'select_splits_settle_all_confirm_received',
  SELECT_SPLITS_GET_MODAK: 'select_splits_get_modak',
  SELECT_SPLITS_CONTROL: 'select_splits_control',
  API_SPLITS_GET_ACTIVITY_SUCCESS: 'api_splits_get_activity_success',
  API_SPLITS_GET_ACTIVITY_ERROR: 'api_splits_get_activity_error',
  // Mochat
  VIEW_MO_RESPONSE_ERROR: 'view_mo_response_error',
  VIEW_MO_MESSAGE_RECEIVED: 'view_mo_message_received',
  SELECT_MO_MESSAGE_SENT: 'select_mo_message_sent',
  VIEW_MO_SPLIT_PROPOSAL: 'view_mo_split_proposal',
  SELECT_MO_SPLIT_PROPOSAL_UNDO: 'select_mo_split_proposal_undo',
  SELECT_MO_SPLIT_PROPOSAL_CONFIRM: 'select_mo_split_proposal_confirm',
  API_MO_ADD_SPLIT_SUCCESS: 'api_mo_add_split_success',
  API_MO_ADD_SPLIT_ERROR: 'api_mo_add_split_error',
  SELECT_MO_COPY_SPLIT_LINK: 'select_mo_copy_split_link',
  SELECT_MO_SHARE_SPLIT_LINK: 'select_mo_share_split_link',
  SHARE_MO_SPLIT_LINK_SUCCESS: 'share_mo_split_link_success',
} as const;
